<template>
  <div class="drillrow_controls text-medium">
    <div
      class="gw_btn csst csst_nm clr-white"
      data-tst="btn_export_drill"
      @click.stop="e => copyToClipboard(e)"
      @mouseleave="copied = false"
    >
      <div class="mdi mdi-tray-arrow-up"></div>
      <div
        class="csst_content drillrow_controls_tooltip text-nowrap"
        style="position: absolute; left: 0; transform: translate(calc(-100% - 2px), 0)"
        :class="{ csst_content_visible: copied }"
        :style="copied ? 'background: var(--clr-primary)' : ''"
        v-html="copied ? $t('tooltips.drill_copied_to_clipboard') : $t('tooltips.export_drill')"
      ></div>
    </div>

    <div
      class="csst csst_nm gw_btn clr-white"
      :class="{ 'no-events': loadingNewDrill }"
      data-tst="btn_clone_drill"
      @click.stop="cloneDrill"
      @mouseenter="e => fl_positionTooltip(e, { placement: 'left' })"
    >
      <LoaderSpinner
        v-if="loadingNewDrill"
        style="--size: 0.875rem"
      />
      <div
        v-else
        class="mdi mdi-content-copy"
      ></div>
      <div
        class="csst_content drillrow_controls_tooltip"
        style="position: fixed"
        v-html="$t('tooltips.clone_drill')"
      ></div>
    </div>

    <div
      v-if="!item.public"
      class="csst csst_nm gw_btn clr-white"
      data-tst="btn_edit_drill"
      @click.stop="openAdvancedFilter"
      @mouseenter="e => fl_positionTooltip(e, { placement: 'left' })"
    >
      <LoaderSpinner
        v-if="loadingGmf && clickedBtn === 'pencil'"
        data-tst="btn_edit_drill_spinner"
        style="--size: 0.875rem"
      />
      <div
        v-else
        class="mdi-pencil mdi"
      ></div>
      <div
        class="csst_content drillrow_controls_tooltip"
        style="position: fixed"
        v-html="$t('tooltips.edit_drill')"
      ></div>
    </div>

    <div
      class="csst csst_nm gw_btn clr-white"
      style="--clr-hover-white: var(--clr-primary)"
      data-tst="btn_start_drill"
      @click.stop="play"
      @mouseenter="e => fl_positionTooltip(e, { placement: 'left' })"
    >
      <LoaderSpinner
        v-if="loadingGmf && clickedBtn === 'play'"
        data-tst="btn_start_drill_spinner"
        style="--size: 0.875rem"
      />
      <div
        v-else
        class="mdi mdi-play"
      ></div>
      <div
        style="position: fixed"
        class="csst_content drillrow_controls_tooltip"
        v-html="$t('btn.start_drill')"
      ></div>
    </div>
  </div>
</template>

<script>
import LoaderSpinner from '@/components/Loaders/LoaderSpinner'
import { getGameformatGroup } from '@/store/gameformat/gameformat'
import float_mix from '@/mixins/float_mix'
import format_mix from '@/mixins/format_mix'

export default {
  name: 'DrillTableRowControls',
  components: {
    LoaderSpinner,
  },
  mixins: [float_mix, format_mix],
  props: {
    namespace: { String, required: true },
    item: Object,
  },
  data() {
    return {
      copied: false,
      loadingNewDrill: false,
      loadingGmf: false,
      clickedBtn: '',
    }
  },
  methods: {
    async fetchGmfAndReturnStatus() {
      if (this.loadingGmf) return 'in-progress'

      const mode = getGameformatGroup(this.item.query.gametype)
      if (!this.$store.getters.gameformats_groupsSet[mode]) {
        this.loadingGmf = true
        const result = await this.$store.dispatch('get_gameformat_groups', [mode])
        this.loadingGmf = false
        if (!result || result.error) return 'error'
      }
      return 'continue'
    },
    async play() {
      this.clickedBtn = 'play'
      if ((await this.fetchGmfAndReturnStatus()) !== 'continue') return

      if (!this.$store.getters.hands_configure) {
        this.setSelectedDrill()
        const dialog = `trainer-restore-hand-dialog_action-startdrill`
        this.$store.dispatch('router_set_dialogs', dialog)
        return
      }
      this.$store.dispatch('drills_start_drill', { drill: this.item })
    },
    async openAdvancedFilter() {
      this.clickedBtn = 'pencil'
      if ((await this.fetchGmfAndReturnStatus()) !== 'continue') return

      this.setSelectedDrill()
      this.$store.dispatch(`${this.namespace}/router_update_query`, {
        query: this.item.query,
        push: false,
        replace: true,
        saveLocally: false,
      })
      const apiAction = this.item.public ? 'newdrill' : 'editdrill'
      const dialog = `trainer-advanced-filter-dialog_namespace-${this.namespace}_tmpNamespace-${this.namespace}_${apiAction}`
      this.$store.dispatch('router_set_dialogs', dialog)
    },
    setSelectedDrill() {
      this.$store.commit('drills_set', { key: 'drills_selected_drill', value: this.item })
    },
    cloneDrill() {
      let name = `${this.item.name} (copy)`
      if (name.length) {
        name = name.substring(0, 256)
      }
      const items = [
        {
          ...this.item,
          id: '',
          name,
          tags: this.item.public ? [] : this.item.tags,
        },
      ]
      this.loadingNewDrill = true
      this.$store.dispatch('drills_set_drill', {
        items,
        hasMessage: false,
        method: 'POST',
        hasExpectedResponse: false,
      })
    },
    copyToClipboard(e) {
      this.copied = true
      const res = {
        id: this.item.id,
        query: this.item.query,
        name: this.item.name,
        description: this.item.description,
      }
      const str = JSON.stringify(res)
      navigator.clipboard.writeText(str)
      setTimeout(() => {
        this.copied = false
      }, 1000)
    },
  },

  watch: {
    item() {
      if (!this.loadingNewDrill) return
      this.loadingNewDrill = false
    },
  },
}
</script>
<style lang="scss" scoped>
.drillrow {
  &_controls {
    display: flex;
    gap: 0.25rem;
    &_tooltip {
      position: fixed;
      white-space: nowrap;
    }
  }
}
</style>
